module.exports = __webpack_public_path__ + "img/minsubowuguan.cb0c9d32.png";